/**
 * Checks on a user that a super admin is looking at or editing. Nobody but super
 * admins uses this app, so there is nothing to check about the caller.
 */

/**
 * DD-3391: the three external user tiers. Mirrored from
 * shared-denthub-code/src/models/external-user-role.ts.
 */
export const EXTERNAL_USER_ROLES = ['RESTRICTED_EXTERNAL_USER', 'EXTERNAL_TECHNICIAN', 'ELEVATED_EXTERNAL_USER'];

export const permissions = {
    isDentist: (userType?: string): boolean => userType === 'dentist',

    isLabTechnician: (userType?: string): boolean => userType === 'lab_technician',

    /** True for every external tier, not just the legacy EXTERNAL_TECHNICIAN role (DD-3391). */
    isExternalTechnician: (userRole?: string): boolean => EXTERNAL_USER_ROLES.includes(userRole as string),
};
